export default __webpack_public_path__ + "static/media/play.dc4eb364.svg";